import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

import getters from './getters';
import mutations from './mutations';
import actions from './actions';

export default new Vuex.Store({

    state: {
        currentUser: null,
        pageIsLoading: false,
        pageTitleUpdated: false,
        labels: [],
        languages: [],
        lang: {
            currentString: '',
            showModal: false,
        },
        snackbars: [],
        articles: {},
        conditionBoxToggleList:[],
        isBundleAttribute: null,
        showArticlePropertiesTabUnit: '',
        valueChainProperties:{
          isFormValid: true,
          saved: false,
        },
        sessionExpired: false,
        selectedBundles: [],
        batchList: [],
    },

    mutations,
    getters,
    actions,

    modules: {

    }

})
